    var interval = 600000;

    function reset()
    {
        localStorage.endTime = + new Date + interval;
    }
    
    if(!localStorage.endTime)
    {
        var xhr = new XMLHttpRequest();
        xhr.open("POST", '/cart/update.js', true);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.send(JSON.stringify({ attributes: {'collection_handle': null,
        'collection_title': null } }));
        reset();
    }

    setInterval(function() {
        var remaining = localStorage.endTime - new Date;
        
        if( remaining >= 0 ) {

        } else {
            var xhr = new XMLHttpRequest();
            xhr.open("POST", '/cart/update.js', true);
            xhr.setRequestHeader('Content-Type', 'application/json');
            xhr.send(JSON.stringify({ attributes: {'collection_handle': null,
            'collection_title': null } }));
            console.log('15 seconds passed')
            reset();
        }
    }, 100);